import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { poolContributionsDataProvider } from './dataProvider';

export function initSocialTradingPoolContributionsDataProvider() {
  registerModuleDataProvider(Resources.socialTradingPoolContributions, poolContributionsDataProvider);
}

initSocialTradingPoolContributionsDataProvider();
